module.exports = __webpack_public_path__ + "img/resource_center.1e2895c1.png";